'use client';

import Image from 'next/image';

import Modal from '@src/components/atoms/modal'

// Assets
import XIcon from '@public/png/x-1.png';
import ArrowLeft from "@public/png/arrow-left-2.png"

const ModalBantuanSearchListListing = ({ onClose, onSuggestLocation, onTanyaMarketing, ...props }) => {
  return (
    <Modal {...props} onClose={onClose} className="!items-start dd2-xl:hidden">
      <div className='relative mt-[56px] z-[42] w-[460px] rounded-[12px] bg-white p-4'>
        <button className='absolute z-[42] p-1 -top-8 right-0 flex justify-center items-center bg-white rounded-[40px]'>
          <Image
            width={16}
            height={16}
            src={XIcon}
            alt='Close'
            className='object-contain'
            onClick={onClose}
          />
        </button>

        <div className='mb-4'>
          <p className='text-22 font-sfpro-bold mb-2'>Mengapa lokasi tidak ditemukan?</p>
          <p className='text-17 mb-6'>Lokasi tidak ditemukan terjadi karena beberapa hal, seperti:</p>
          <ul className='px-6'>
            <li className='text-17 mb-4 list-disc'>ada kesalahan penulisan lokasi pada kolom pencarian;</li>
            <li className='text-17 mb-4 list-disc'>lokasi yang dimasukkan bukan kategori area/kota;</li>
            <li className='text-17 mb-4 list-disc'>lokasi yang dimasukkan belum terdaftar dalam basis data kami;</li>
            <li className='text-17 list-disc'>belum ada properti yang terdaftar untuk lokasi yang dimasukkan.</li>
          </ul>
        </div>
        <div className='mb-4'>
          <p className='text-22 font-sfpro-bold mb-2'>Solusi</p>
          <ol className='px-6'>
            <li className='text-17 mb-4 list-decimal'>cek kembali penulisan lokasi pada kolom pencarian;</li>
            <li className='text-17 mb-4 list-decimal'>bantu kami menambahkan lokasi yang diinginkan dengan cara mengisi form saran;</li>
            <li className='text-17 list-decimal'>silahkan konsultasi langsung dengan marketing kami </li>
          </ol>
        </div>

        {/* <div className='flex items-center justify-end'>
          <button type='button' onClick={onSuggestLocation} className='text-17 mr-4 font-sfpro-semibold underline'>Saran Lokasi</button>
          <button type='button' onClick={onTanyaMarketing} className='py-2.5 px-[12px] rounded-[40px] text-17 mr-4 font-sfpro-semibold bg-[#FFC72C]'>Tanya Marketing</button>
        </div> */}
      </div>
    </Modal>
  )
}

const ModalBantuanSearchListListingMobile = ({ onClose, onSuggestLocation, onTanyaMarketing, ...props }) => {
  return (
    <Modal {...props} onClose={onClose} className="!items-start hidden dd2-xl:flex">
      <div className='z-[42] w-screen h-screen bg-white p-4 overflow-y-auto'>
        <div className='h-full flex flex-col item justify-between'>
          <div>
            <div className='flex items-center justify-between mb-4 pb-4'>
              <button className='w-[40px] h-[40px] mr-4 flex justify-center items-center bg-[#F6F6F6] rounded-[40px]'>
                <Image
                  width={20}
                  height={20}
                  src={ArrowLeft}
                  alt='Close'
                  className='object-contain'
                  onClick={onClose}
                />
              </button>

              <span className='text-17'>Bantuan</span>
            </div>

            <div className='mb-4'>
              <p className='text-22 font-sfpro-bold mb-2'>Mengapa lokasi tidak ditemukan?</p>
              <p className='text-17 mb-6'>Lokasi tidak ditemukan terjadi karena beberapa hal, seperti:</p>
              <ul className='px-6'>
                <li className='text-17 mb-4 list-disc'>ada kesalahan penulisan lokasi pada kolom pencarian;</li>
                <li className='text-17 mb-4 list-disc'>lokasi yang dimasukkan bukan kategori area/kota;</li>
                <li className='text-17 mb-4 list-disc'>lokasi yang dimasukkan belum terdaftar dalam basis data kami;</li>
                <li className='text-17 list-disc'>belum ada properti yang terdaftar untuk lokasi yang dimasukkan.</li>
              </ul>
            </div>
            <div className='mb-4'>
              <p className='text-22 font-sfpro-bold mb-2'>Solusi</p>
              <ol className='px-6'>
                <li className='text-17 mb-4 list-decimal'>cek kembali penulisan lokasi pada kolom pencarian;</li>
                <li className='text-17 mb-4 list-decimal'>bantu kami menambahkan lokasi yang diinginkan dengan cara mengisi form saran;</li>
                <li className='text-17 list-decimal'>silahkan konsultasi langsung dengan marketing kami </li>
              </ol>
            </div>
          </div>

          {/* <div className='flex items-center justify-end'>
            <button type='button' onClick={onSuggestLocation} className='text-17 mr-4 font-sfpro-semibold underline'>Saran Lokasi</button>
            <button type='button' onClick={onTanyaMarketing} className='py-2.5 px-[12px] rounded-[40px] text-17 mr-4 font-sfpro-semibold bg-[#FFC72C]'>Tanya Marketing</button>
          </div> */}
        </div>
      </div>
    </Modal>
  )
}

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null
  return (
    <>
      <ModalBantuanSearchListListing isOpen={isOpen} {...props} />
      <ModalBantuanSearchListListingMobile isOpen={isOpen} {...props} />
    </>
  )
}

export default Wrapper